module.exports = __webpack_public_path__ + "img/macchinaWhite.f1f5ff7c.svg";